module.exports = __webpack_public_path__ + "img/theorie-lazy.11a37576.jpg";